import request from "../Tools/request/request";

// 咨询管理-列表
export function getConsultList(data) {
    return request({
        url: "/portal/ask/list",
        method: "post",
        data,
    });
}
// 咨询管理-回复
export function getConsultReply(data) {
    return request({
        url: "/portal/update",
        method: "post",
        data,
    });
}
